// extracted by mini-css-extract-plugin
export default {"JobForm":"styles_JobForm__8DovL"};